"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
const app_1 = require("./app");
const responseError = require("./common/responseError");
const identifiers_1 = require("./identifiers");
const _ = require("lodash");
function updateCourseWork(courseWorkId, sourceObj) {
    return __awaiter(this, void 0, void 0, function* () {
        try {
            const courseWorksRef = app_1.app.firestore.collection('courseWorks').doc(courseWorkId);
            const { assignStudentIds, deassignStudentIds, courseWorkState } = sourceObj;
            let message = 'coursework updated sucessfully';
            if (assignStudentIds || deassignStudentIds) {
                yield app_1.app.firestore.runTransaction((transaction) => __awaiter(this, void 0, void 0, function* () {
                    const courseWorkDoc = yield transaction.get(courseWorksRef);
                    if (courseWorkDoc.exists) {
                        const url = 'https://us-central1-omega-rhino-227310.cloudfunctions.net/updateCourseWorkOnGoogleClassRoom';
                        const result = yield fetch(url, {
                            method: 'POST',
                            body: JSON.stringify({ courseWorkDoc: courseWorkDoc.data(), sourceObj }),
                            headers: {
                                'Content-Type': 'application/json'
                            }
                        });
                        const data = yield result.json();
                        const googleClassRoomInfo = data.data.googleClassRoomInfo;
                        const individualStudentOptions = courseWorkDoc.data().individualStudentsOptions;
                        const assigneeMode = courseWorkDoc.data().assigneeMode;
                        switch (assigneeMode) {
                            case identifiers_1.Types.AssigneeModes.INDIVIDUAL_STUDENTS: {
                                // remove studentIds
                                const removedIndividualStudentOptions = _.without(individualStudentOptions, ...deassignStudentIds);
                                // add studentIds on removed studentIds
                                const addedIndividualStudentOptions = _.union(removedIndividualStudentOptions, assignStudentIds);
                                // set final studentIds
                                const finalIndividualStudentOptions = addedIndividualStudentOptions;
                                transaction.update(courseWorksRef, {
                                    individualStudentsOptions: finalIndividualStudentOptions,
                                    googleClassRoomInfo
                                });
                                break;
                            }
                            default:
                                console.warn(`Unsupported assignee mode for this coursework : ${assigneeMode}.`);
                                break;
                        }
                    }
                    else {
                        message = `coursework with given id does not exist in database. courseworkid : ${courseWorkId}`;
                    }
                }));
            }
            if (courseWorkState) {
                yield courseWorksRef.update({ courseWorkState });
            }
            return { id: courseWorkId, message };
        }
        catch (e) {
            throw new responseError.HttpsError(responseError.FunctionsErrorCode.invalid_argument, e.message);
        }
    });
}
exports.default = updateCourseWork;
//# sourceMappingURL=updateCourseWork.js.map